module.exports = __webpack_public_path__ + "static/stoli-d20aef3a99ef0f5afc9fcb190ac8daac.png";